import { Molecule, wrap, Wrapper } from "AppReact";
import styled, { css } from "styled-components";
import {
  Mb11,
  Mb3,
  Mb8,
  GenericWrapper,
  FlexCenterJustifyCenterWrapper,
} from "wrappers";
import { Empty, PrimaryTextLg, SecondaryTextSm300 } from "atoms";
import getIsMobile from "components/atoms/utils/getIsMobile";
import { UpSquareArrowSvg } from "components/icons/UpSquareArrowSvg";
import SolidButton from "./solidButton";


const template = styled.label`
  ${({ isHovered }) => css`
    margin: 0;
    height: calc(100vh - 300px);
    max-height: 470px;
    display: grid;
    place-items: center;
    min-width: 250px;
    width: 100%;
    background: #ffffff;
    border: ${isHovered
      ? `1px solid ${window?.settings?.primary_color ?? "#1DBD6B"}`
      : "unset"};
    border-radius: 8px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23E3E3E3' strokeWidth='2' stroke-dasharray='10%2c 10' stroke-dashoffset='30' strokeLinecap='square'/%3e%3c/svg%3e");
    cursor: pointer;
    padding-left: 16px;

    &:hover {
      border: 1px solid ${window?.settings?.primary_color ?? "#1DBD6B"};
      background-image: unset;
    }

    @media only screen and (min-width: 768px) {
      padding-left: unset;
    }
  `}
`;

export default Molecule({
  template,
  type: "dropFiles",
  atoms: [
    {
      wrapper: GenericWrapper,
      name: "Wrapper",
      atoms: [
        {
          component: wrap(wrap(Empty, FlexCenterJustifyCenterWrapper), Mb11),
          name: "Icon",
          displayValue: ({}) => UpSquareArrowSvg({}),
        },
        {
          wrapper: Wrapper(styled.div`
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
          `),
          name: "Wrapper",
          atoms: [
            {
              component: wrap(PrimaryTextLg, Mb3),
              name: "FirstText",
              displayValue: ({}) => "Drop video to upload",
            },
            {
              component: wrap(SecondaryTextSm300, Mb8),
              name: "SecondText",
              displayValue: ({}) => "or",
            },
            {
              component: SolidButton,
              name: "Button",
              bindings: ({}) => ({
                action: "upload",
                title: "Select Video",
                big: true,
              }),
            },
          ],
        },
      ],
    },
  ],
});
